import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from "react-redux";
import { Button, Card, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { efectorHorarioSeleccionar, efectorHorariosUpdateDisabled, generarTurnosPorEfectorHorario, habilitarInhabilitarEfectorHorario } from '../../../../actions/turnos/efectorHorarios';
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../../utils/permisos';
import { startAlerta } from '../../../../actions/ui/alertas';
import { ModalPisoConsultorio } from '../parametrizaciones/ModalPisoConsultorio';
import { TransferWithinAStationSharp } from '@material-ui/icons';

const style = {
    cell: {
        padding: 8,
        textAlign: 'center',
    },
    cellTime: {
        padding: 8,
        letterSpacing: -1,
        textAlign: 'center',
    },
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop: 0,
        marginBottom: 0,
    },
};

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatTime = time => {
    return time.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

export const ListaDiasEventuales = (props) => {
    const dispatch = useDispatch();
    const { setearVariosValores, setSelectedDay, setSelectedDate, validarSoloUnPermiso, permisosUser, items, cargada, setEditarPisoConsultorio, setBotonActualizar } = props;

    const [openModalPisoConsultorio, setOpenModalPisoConsultorio] = useState(false);
    const [info, setInfo] = useState('');

    const handleEditItem = item => {
        setEditarPisoConsultorio(true);
        setBotonActualizar(true);
        dispatch(efectorHorarioSeleccionar(item));
        const itemRefactored = {
            ...item,
            presencial: (item.idTipoTurno === 1 || item.idTipoTurno === 3) ? true : false,
            virtual: (item.idTipoTurno === 2 || item.idTipoTurno === 3) ? true : false
        }
        setearVariosValores(itemRefactored);
        setSelectedDate(item.fechaInicio);
        setSelectedDay(item.dia);
        if (!item.generacionInicial || item.inHabilitado)
            dispatch(efectorHorariosUpdateDisabled(false));
        else
            dispatch(startAlerta('Solo puede editar parametrizaciones que no se hayan generado o inhabilitadas', "warning", `¡Atención!`));
    }

    const handleEnabledParametrizacion = (idEfHorario, inHabilitado) => {
        dispatch(habilitarInhabilitarEfectorHorario(idEfHorario, inHabilitado));
    }

    const handleGenerarAgenda = idEfHorario => {
        dispatch(generarTurnosPorEfectorHorario(idEfHorario));
    }

    const validateDisabled = (item) => {
        if (item.inHabilitado || item.demanda)
            return true;
        else if (validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.GENERACION_ADMIN))
            return false;
        else if (item.generacionInicial || !validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION))
            return true;
    }

    const handleEditPisoConsultorio = (item) => {
        setInfo(item);
        setOpenModalPisoConsultorio(true);
    }

    return (
        <>
            {openModalPisoConsultorio && (
                <ModalPisoConsultorio
                    open={openModalPisoConsultorio}
                    close={() => {
                        setOpenModalPisoConsultorio(false);
                    }}
                    disabled={false}
                    info={info}

                />
            )}
            {cargada &&
                <Card>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Dia</TableCell>
                                    <TableCell align="left" style={style.cell}>Hora Inicio</TableCell>
                                    <TableCell align="left" style={style.cell}>Hora Fin</TableCell>
                                    <TableCell align="left" style={style.cell}>Duracion</TableCell>
                                    <TableCell align="left" style={style.cell}>Edad Mínima</TableCell>
                                    <TableCell align="left" style={style.cell}>Edad Máxima</TableCell>
                                    <TableCell align="left" style={style.cell}>Presencial</TableCell>
                                    <TableCell align="left" style={style.cell}>Virtual</TableCell>
                                    <TableCell align="left" style={style.cell}>Demanda</TableCell>
                                    <TableCell align="left" style={style.cell}>Cant. Sobre Turnos</TableCell>
                                    <TableCell align="left" style={style.cell}>Fecha</TableCell>
                                    <TableCell align="left" style={style.cell}>Habilitado</TableCell>
                                    <TableCell align="left" style={style.cell}>Piso</TableCell> {/* 4 caracteres numericos */}
                                    <TableCell align="left" style={style.cell}>Consultorio</TableCell> {/* alfanumerico */}
                                    <TableCell align="left" style={style.cell}>Recepcion</TableCell> {/* alfanumerico */}
                                    <TableCell align="left"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                    // items.map((item) => (
                                    items.sort((a, b) => new Date(a.fechaInicio) - new Date(b.fechaInicio)).map((item) => {
                                        const isDisabled = validateDisabled(item);

                                        return (
                                            <TableRow key={item.idEfHorario}>
                                                <TableCell align="left" style={style.cell}>
                                                    <IconButton style={{ padding: 0, margin: 0 }}
                                                        onClick={(e) => handleEditPisoConsultorio(item)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        color="primary"
                                                        aria-label="Editar"
                                                    >
                                                        <TransferWithinAStationSharp style={style.iconButton} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    <IconButton style={{ padding: 0, margin: 0 }}
                                                        onClick={(e) => handleEditItem(item)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        color="primary"
                                                        aria-label="Editar"
                                                    >
                                                        <EditIcon style={style.iconButton} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.dia}
                                                </TableCell>
                                                <TableCell align="left" style={style.cellTime}>
                                                    {`${formatTime(item.horaDesde)} : ${formatTime(item.minDesde)}`}
                                                </TableCell>
                                                <TableCell align="left" style={style.cellTime}>
                                                    {`${formatTime(item.horaHasta)} : ${formatTime(item.minHasta)}`}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.demanda ? `` : `${item.duracion} Min`}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell} >
                                                    {item.edadMinima}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell} >
                                                    {item.edadMaxima}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Checkbox
                                                        name="presencial"
                                                        checked={(item.idTipoTurno === 1 || item.idTipoTurno === 3) ? true : false}
                                                        disabled={true}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    <Checkbox
                                                        name="virtual"
                                                        checked={(item.idTipoTurno === 2 || item.idTipoTurno === 3) ? true : false}
                                                        disabled={true}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={style.cell} >
                                                    <Checkbox
                                                        className={style.checkbox}
                                                        checked={item.demanda}
                                                        disabled={true}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.demanda ? `` : `${item.cantSobreTurnos}`}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {new Date(item.fechaInicio).toLocaleString(
                                                        "es",
                                                        optionsfecha
                                                    )}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell} >
                                                    <Checkbox
                                                        name="inHabilitado"
                                                        checked={!item.inHabilitado}
                                                        onClick={() => handleEnabledParametrizacion(item.idEfHorario, !item.inHabilitado)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.piso}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.consultorio}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.recepcion}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disabled={isDisabled}
                                                        // disabled={item.generacionInicial || item.inHabilitado || item.demanda || !validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        onClick={() => handleGenerarAgenda(item.idEfHorario)}
                                                    >
                                                        Generar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                    :
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell colSpan={12} style={{ textAlign: '-webkit-center' }}> Sin Registros</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            }
        </>
    );
}